module.exports = __webpack_public_path__ + "img/code.ecd1b655.jpg";